export const extractPath = (str: string) => {
  try {
    return new URL(str).pathname;
  } catch (e) {
    return undefined;
  }
};
